import * as React from 'react';
import InputErrorClass from 'src/components/Shared/InputErrorClass';

export default class Text extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const { values, errors, handleChange } = this.props;

    return (
      <div>
        <div className="form-group">
          <label>Subtipo</label>
          <select
            className={InputErrorClass({ errors, name: 'data.type' })}
            name="data.type"
            onChange={handleChange}
            value={values.data.type}
          >
            <option value=""></option>
            <option value="form">Formulario</option>
            <option value="phone">Llamanos</option>
            <option value="form_phone">Mixto</option>
          </select>
          {errors['data.type'] && <p className="invalid-feedback">{errors['data.type']}</p>}
        </div>
        <hr/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Module/Types/Contact.tsx